<template>
    <div class="browsingHistoryContent">
        <el-button class="emptyButton" @click="empty">清空</el-button>
        <el-timeline v-show="browsingHistoryList.length > 0">
            <el-timeline-item :timestamp="item.time" placement="top" type="primary" v-for="(item,index) in browsingHistoryList" class="timelineItemClass" :key="index">
                <el-card v-for="(card,index) in item.commodityList" :key="index">
                    <div class="total">共计{{item.commodityList.length}}条</div>
                    <div class="cardContent">
                        <a :href="card.link" target="_blank"><img :src="card.logo" alt="">
                        <div class="cardBottom">
                            <div class="name">
                                <span>[{{card.typeCn}}]</span>
                                {{card.title}}
                            </div>
                            <div class="priceContent">
                                <div class="price"><span v-show="card.price !== '议价'">￥</span>{{card.price==null?"0":card.price}}</div>
                                <div class="enquiry">
                                    <el-button><i class="el-icon-s-comment"></i> 立即询价</el-button>
                                </div>
                            </div>
                        </div></a>
                    </div>
                </el-card>
            </el-timeline-item>
        </el-timeline>
        <!-- <p class="noData" v-show="browsingHistoryList.length <= 0">暂无浏览记录</p> -->
        <p class="noData" v-show="browsingHistoryList.length <= 0">
          <img src="../../assets/暂无关注.jpg" alt="" style="width:200px">
        </p>
    </div>
</template>

<script>
    import {queryVisitorLog, deleteVisitorLog} from "../../utils/stationMessageLog";

    export default {
        name: "browsingHistory",
        data(){
            return{
                browsingHistoryList: []
            }
        },
        created() {
            this.getList();
        },
        methods: {
            // 清空
            empty(){
                this.loading = true

                this.$confirm('确定清除数据吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return deleteVisitorLog();
                }).then(() => {
                    this.$message.success("清除成功");
                    this.getList();
                }).catch(function() {
                    this.$message.error("清除失败");
                });
            },
            getList(){
                this.loading = true
                queryVisitorLog().then((res)=>{
                    if(res){
                        this.browsingHistoryList =res;
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
.browsingHistoryContent{
    padding: 30px;
    position: relative;
    .noData{
        text-align: center;
        position: absolute;
        top: 300px;
        left: 50%;
        margin: 0;
    }
    .emptyButton{
        position: fixed;
        top: 80px;
        right: 40px;
        padding: 8px 15px;
        font-size: 12px;
        color: #fff;
        background: #157efb;
        border: none;
        z-index: 999;
    }
    img{
        width: 195px;
        height: 130px;
        display: block;
        margin: 0 auto;
    }
    .timelineItemClass{
        /deep/.el-timeline-item__content{
            display: flex;
            flex-wrap: wrap;
        }
        position: relative;
        .total{
            position: absolute;
            left: 115px;
            top: -1px;
            font-size: 13px;
            font-weight: 400;
            color: #909399;
        }
    }
    /deep/.el-card{
        width: 225px;
        margin-right: 30px;
        margin-bottom: 20px;
        /deep/.el-card__body{
            padding: 15px;
        }
    }
    .cardBottom{
        .name{
            min-height: 38px;
            width: 100%;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            span{
                color: #157EFB;
            }
        }
        .priceContent{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .price{
                color: #ff0000;
            }
            .enquiry{
                button{
                    font-size: 12px;
                    color: #fff;
                    padding: 8px 10px;
                    background: #157efb;
                    border: none;
                    i{
                        font-size: 16px;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/browsingHistory/browsingHistory.vue